module.exports = __webpack_public_path__ + "media/Homepage_mobile.78db9010.webm";